export default "__VITE_ASSET__Ii6zvG44__"